import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/no-explicit-any */
import { CatButton } from "blocks-nextjs/blocks-react/components/Button/Button";
import { CatContextualMenu } from "blocks-nextjs/blocks-react/components/ContextualMenu/ContextualMenu";
import { CatHeading } from "blocks-nextjs/blocks-react/components/Heading/Heading";
import { CatIconArrowDown } from "blocks-nextjs/blocks-react/components/Icons/ArrowDown/ArrowDown";
import { CatIconArrowUp } from "blocks-nextjs/blocks-react/components/Icons/ArrowUp/ArrowUp";
import { CatList } from "blocks-nextjs/blocks-react/components/List/List";
import { CatListItem } from "blocks-nextjs/blocks-react/components/ListItem/ListItem";
import { CatLoadingIndicator } from "blocks-nextjs/blocks-react/components/LoadingIndicator/LoadingIndicator";
import { CatPagination } from "blocks-nextjs/blocks-react/components/Pagination/Pagination";
// import { CatStatusIndicator } from "blocks-nextjs/blocks-react/components/StatusIndicator/StatusIndicator";
import { CatTable } from "blocks-nextjs/blocks-react/components/Table/Table";
import { CatTableBody } from "blocks-nextjs/blocks-react/components/TableBody/TableBody";
import { CatTableCell } from "blocks-nextjs/blocks-react/components/TableCell/TableCell";
import { CatTableHeader } from "blocks-nextjs/blocks-react/components/TableHeader/TableHeader";
import { CatTableHeaderCell } from "blocks-nextjs/blocks-react/components/TableHeaderCell/TableHeaderCell";
import { CatTableRow } from "blocks-nextjs/blocks-react/components/TableRow/TableRow";
import { format } from "date-fns";
import React, { useCallback, useEffect, useState } from "react";
import { isTimeOnlyTimestamp } from "../../pages/Projects/ProjectDetails.helper";
// import { getLocalTime } from "../../pages/Projects/ProjectDetails.helper";
import { getAssetFaultsSearch } from "../../services/api/asset-faults.service";
import { getAssetFaultsCount } from "../../services/api/asset-faults.service";
import { PROJECT_NAME_MALAGA } from "../../shared/constants";
import { getTimezoneAbbr as getSharedTimezoneAbbr } from "../../shared/helper";
import useAppConfigStore from "../../store/useAppConfigStore";
import { AssetFaultTypePropertyForFiltering } from "../../swagger/caas-v1/models/AssetFaultTypePropertyForFiltering";
import { FaultPropertiesForFiltering } from "../../swagger/caas-v1/models/FaultPropertiesForFiltering";
import { safeFormatInTimeZone } from "../../utils/dateFormatter";
const Alerts = (props) => {
    const { assetId, isRefreshComponent, last24hrsAlertsCount, projectId, projectName, timezone } = props;
    const [alertsSortOrder, setAlertsSortOrder] = useState("DESC");
    const [assetFaultsData, setAssetFaultsData] = useState([]);
    const [assetFaultsCount, setAssetFaultsCount] = useState([]);
    const [faultsDataOnPage, setFaultsDataOnPage] = useState({});
    const [pageNumber, setPageNumber] = useState(1);
    const [isLoading, setIsLoading] = useState(false);
    const faultsPerPage = 5;
    const { appConfig } = useAppConfigStore((state) => ({
        appConfig: state.appConfig
    }));
    // Feature flag interpretation: When TRUE, API sends properly formatted timestamps (new behavior)
    // When FALSE, legacy API requires manual timestamp formatting (old behavior)
    const useLegacyTimestampHandling = !appConfig?.release_1_1?.showCestTimezone;
    const filterFields = [
        { propertyName: AssetFaultTypePropertyForFiltering.ASSET_ID, type: "stringEquals" },
        { propertyName: FaultPropertiesForFiltering.FAULT_REPORTED_TIME, type: "timeRange" },
        { propertyName: AssetFaultTypePropertyForFiltering.PROJECT_ID, type: "stringEquals" }
    ];
    const prepareRequestBodyFilters = (isLast24hrsCount) => {
        let timeFilterValue;
        //converting time into cest
        // const timeoffset = +new Date(getLocalTime(new Date().toISOString(), offset));
        //converting time into utc
        const timeoffset = Date.parse(new Date().toISOString());
        if (isLast24hrsCount) {
            timeFilterValue = new Date(timeoffset - 24 * 60 * 60 * 1000).toISOString();
        }
        else {
            timeFilterValue = new Date(timeoffset - 10 * 24 * 60 * 60 * 1000).toISOString();
        }
        // When showCestTimezone is TRUE, replace "Z" with timezone offset
        // Example: "2025-12-11T21:27:02.981Z" → "2025-12-11T21:27:02.981+01:00"
        if (!useLegacyTimestampHandling) {
            // Get the timezone offset for Amsterdam (CEST is UTC+2, CET is UTC+1)
            // Create a date in the project timezone to determine the current offset
            const date = new Date(timeFilterValue);
            const formatter = new Intl.DateTimeFormat("en-US", {
                timeZone: timezone || "Europe/Amsterdam",
                timeZoneName: "longOffset"
            });
            // Extract offset from formatted string (e.g., "GMT+01:00" or "GMT+02:00")
            const parts = formatter.formatToParts(date);
            const offsetPart = parts.find((part) => part.type === "timeZoneName");
            let offset = "+01:00"; // Default to CET
            if (offsetPart?.value) {
                const match = offsetPart.value.match(/GMT([+-]\d{2}:\d{2})/);
                if (match) {
                    offset = match[1];
                }
            }
            // Replace "Z" with the timezone offset
            timeFilterValue = timeFilterValue.replace(/Z$/, offset);
        }
        return filterFields.map((filterField) => {
            if (filterField.type === "stringEquals") {
                return {
                    isCaseSensitive: true,
                    propertyName: filterField.propertyName,
                    type: filterField.type,
                    values: [filterField.propertyName === "assetId" ? assetId : projectId]
                };
            }
            else if (filterField.type === "timeRange") {
                return {
                    propertyName: filterField.propertyName,
                    range: {
                        includeLeft: true,
                        left: timeFilterValue
                    },
                    type: filterField.type
                };
            }
        });
    };
    useEffect(() => {
        if (!isRefreshComponent) {
            setAlertsSortOrder("DESC");
            setPageNumber(1);
            setFaultsDataOnPage({});
            // setLast24hrsFaultsCount({});
            setAssetFaultsData([]);
            setAssetFaultsCount([]);
        }
        else {
            getAssetsFaultsData(pageNumber, alertsSortOrder);
            getAssetsFaultsCountData(true);
            getAssetsFaultsCountData(false);
        }
    }, [assetId, isRefreshComponent]);
    useEffect(() => {
        //Wrapping this in setTimeout without any delay helps us finding the shadow-root element
        setTimeout(() => {
            //Finding the shadow-root element to modify the styles of the pagenation dropdown
            const alertsPaginationDropDown = document
                .querySelector(".alerts-pagination")
                ?.shadowRoot.querySelector(".cat-c-pagination-dropdown");
            alertsPaginationDropDown?.setAttribute("style", "display:none");
            const itemPage = document
                .querySelector(".alerts-pagination")
                ?.shadowRoot.querySelectorAll(".cat-c-pagination-item-page");
            itemPage?.forEach((pageElement) => {
                const pageBtnElement = pageElement?.shadowRoot.querySelector(".cat-c-pagination__item-button");
                if (pageBtnElement?.hasAttribute("currentstateindicator")) {
                    const pageBtn = pageBtnElement?.shadowRoot.querySelector(".cat-c-button--ghost");
                    pageBtn?.setAttribute("style", "background-color: #00447a; color: #FFFFFF; border-radius: 50px; border: 1px solid #00447a;padding: 5px 10px;");
                }
            });
        });
    });
    // Handling timestamp in data to ensure it has the correct format
    // This is used ONLY when the feature flag is OFF for legacy API responses
    // When feature flag is ON, API sends properly formatted timestamps without needing "T" or "Z" appended
    const handleTimestampInData = (assetFaultsData) => {
        const formattedFaultsTimeStampData = assetFaultsData?.faults?.map((data) => {
            let timestamp = data.timestamp || "";
            // Handle time-only format (e.g., "05:00:00") - get today's date in PROJECT timezone
            if (isTimeOnlyTimestamp(timestamp)) {
                const todayInProjectTz = timezone
                    ? safeFormatInTimeZone(new Date(), timezone, "yyyy-MM-dd")
                    : new Date().toISOString().split("T")[0];
                timestamp = todayInProjectTz + "T" + timestamp;
            }
            else if (!timestamp.includes("T")) {
                // Fallback: For timestamps without "T" but not time-only format
                const todayPrefix = new Date().toISOString().split("T")[0] + "T";
                timestamp = todayPrefix + timestamp;
            }
            // When showCestTimezone is TRUE: Remove "Z" to display CEST time as-is
            // When showCestTimezone is FALSE: Add "Z" for UTC timezone parsing
            if (!useLegacyTimestampHandling) {
                // New mode: Remove "Z" if present (e.g., "2025-12-11T21:27:02.981Z" → "2025-12-11T21:27:02.981")
                timestamp = timestamp.replace(/Z$/, "");
            }
            else {
                // Legacy mode: Add "Z" if not present for UTC timezone
                if (!timestamp.includes("Z")) {
                    timestamp = timestamp + "Z";
                }
            }
            return {
                ...data,
                timestamp
            };
        });
        return {
            ...assetFaultsData,
            faults: formattedFaultsTimeStampData
        };
    };
    const getAssetsFaultsData = (currentPage, sort) => {
        setIsLoading(true); // Start loading
        getAssetFaultsSearch({
            filters: prepareRequestBodyFilters(false)
        }, undefined, ["timestamp"], [sort], faultsPerPage, faultsPerPage * (currentPage - 1) || 0)
            .then((response) => {
            // Process timestamps based on feature flag:
            // - Legacy mode (showCestTimezone = false): Only process Malaga timestamps
            // - New mode (showCestTimezone = true): Process all timestamps to remove "Z"
            const needsTimestampProcessing = (useLegacyTimestampHandling && projectName === PROJECT_NAME_MALAGA) || !useLegacyTimestampHandling;
            const data = needsTimestampProcessing ? handleTimestampInData(response) : response;
            setAssetFaultsData(data);
            setFaultsDataOnPage({ ...faultsDataOnPage, [currentPage]: data });
            if (response?.faults?.length > 0) {
                props.isDataAvailableForAsset(true);
            }
        })
            .catch((error) => {
            setAssetFaultsData([{ error: error?.response?.data?.description }]);
            props.isDataAvailableForAsset(false);
        })
            .finally(() => {
            setIsLoading(false); // Stop loading
        });
    };
    const getAssetsFaultsCountData = (isLast24hrs) => {
        getAssetFaultsCount(undefined, {
            filters: prepareRequestBodyFilters(isLast24hrs)
        })
            .then((response) => {
            if (isLast24hrs) {
                last24hrsAlertsCount(response?.count);
            }
            else {
                setAssetFaultsCount(response);
            }
        })
            .catch((error) => {
            if (isLast24hrs) {
                last24hrsAlertsCount(0);
            }
            console.error("Error fetching asset faults count:", error);
        });
    };
    const getTimezoneAbbr = (timestamp) => {
        // For timestamps without "Z", they are already in project timezone
        // We need to determine the DST status based on the date, not the time
        if (timestamp && !timestamp.endsWith("Z")) {
            // Parse date components: "2025-12-18T04:00:00"
            const [datePart] = timestamp.split("T");
            const [year, month, day] = datePart.split("-");
            // Create an ISO string for noon on that date in UTC, then use shared helper
            // This ensures we check DST for the correct date
            const noonUtc = `${year}-${month}-${day}T12:00:00Z`;
            return getSharedTimezoneAbbr(timezone, noonUtc);
        }
        // For timestamps with "Z" or no timestamp, use shared helper directly
        return getSharedTimezoneAbbr(timezone, timestamp);
    };
    const getFormattedTimestamp = useCallback((timestamp) => {
        if (timestamp) {
            try {
                // When showCestTimezone is TRUE: API sends timestamps without "Z" already in project timezone
                // When showCestTimezone is FALSE: API sends UTC timestamps with "Z"
                if (!useLegacyTimestampHandling && !timestamp.endsWith("Z")) {
                    // API sends timestamp already in project timezone (e.g., "2024-01-15T10:00:00" means 10:00 AM project time)
                    // Parse and display the wall-clock time components directly
                    const [datePart, timePart] = timestamp.split("T");
                    const [year, month, day] = datePart.split("-");
                    const [hour, minute] = timePart.split(":");
                    // Format: dd MMM yyyy, HH:mm
                    const date = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
                    const monthName = format(date, "MMM");
                    return `${day} ${monthName} ${year}, ${hour}:${minute}`;
                }
                // Legacy mode or UTC timestamps: Parse and format normally
                const date = new Date(timestamp);
                // Check if the date is valid
                if (isNaN(date.getTime())) {
                    return "";
                }
                // Format using date-fns for consistent output
                return format(date, "dd MMM yyyy, HH:mm");
            }
            catch (error) {
                console.error("Error formatting timestamp:", timestamp, error);
                return "";
            }
        }
        return "";
    }, [useLegacyTimestampHandling, timezone]);
    const populateFaultsData = () => {
        const faults = faultsDataOnPage?.[pageNumber]?.faults;
        return assetFaultsData?.[0]?.error ? (_jsx("div", { className: "flex justify-center items-center h-[100px]", children: assetFaultsData[0].error })) : (faults?.map((fault, index) => {
            const formattedTimestamp = getFormattedTimestamp(fault.timestamp);
            // Calculate timezone abbreviation based on the fault's timestamp for DST awareness
            const timezoneAbbr = timezone ? getTimezoneAbbr(fault.timestamp) : "";
            const recordNumber = (pageNumber - 1) * 5 + (index + 1);
            return (_jsxs(CatTableRow, { children: [_jsx(CatTableCell, { children: _jsxs("div", { className: "flex flex-column items-center ml-[15px] ", children: [_jsx("span", { className: "mr-[15px] min-w-[15px] text-right", children: recordNumber }), _jsx("span", { children: fault.faultDescription })] }) }), _jsx(CatTableCell, { children: _jsxs("div", { className: "flex justify-end items-center h-[32px]", children: [formattedTimestamp, " ", timezoneAbbr] }) })] }, index));
        }));
    };
    const updateSortOrder = (order) => {
        getAssetsFaultsData(pageNumber, order);
        setAlertsSortOrder(order);
    };
    return (_jsxs("div", { className: "flex flex-col gap-3", "data-test": "alerts-container", children: [isLoading && (_jsx("div", { className: "flex justify-center items-center h-[353px]", children: _jsx(CatLoadingIndicator, {}) })), !isLoading && (_jsxs(React.Fragment, { children: [_jsx("div", { className: "h-[290px] overflow-auto", children: _jsxs(CatTable, { arialabel: "Default Table", "data-test": "alerts", children: [_jsx("div", { slot: "caption", children: "Default Table Description" }), _jsx(CatTableHeader, { "data-test": "cat-table-header", isFrozen: true, children: _jsxs(CatTableRow, { children: [_jsx(CatTableHeaderCell, { "data-test": "alerts-header-title", children: _jsx("div", { className: "flex flex-column items-center", children: _jsx(CatHeading, { className: "mr-[10px]", "data-test": "alert-header-text", variant: "title", children: _jsx("div", { className: "text-sm", children: "Alert Description" }) }) }) }), _jsx(CatTableHeaderCell, { "data-test": "sort-header-title", children: _jsx("div", { className: "flex justify-end items-center h-[32px]", children: _jsx("div", { className: "flex items-center list-item-link", children: faultsDataOnPage?.[pageNumber]?.faults?.length > 0 ? (_jsxs(CatContextualMenu
                                                        // className="cat-u-margin-left-sm"
                                                        , { "data-test": "soc-context-menu", position: "bottom", children: [_jsx(CatButton, { slot: "trigger", variant: "ghost", children: _jsx("div", { className: "flex items-center text text-black", children: alertsSortOrder === "DESC" ? (_jsxs(_Fragment, { children: [_jsx(CatIconArrowDown, { className: "items-end self-center height-15px mr-1" }), _jsx("span", { children: "Sort" })] })) : (_jsxs(_Fragment, { children: [_jsx(CatIconArrowUp, { className: "items-end self-center height-15px mr-1" }), _jsx("span", { children: "Sort" })] })) }) }), _jsx("div", { className: "list-item-link", children: _jsxs(CatList, { "data-test": "context-menu-items", slot: "items", children: [_jsx(CatListItem, { "data-test": "sort-by-newest", onBlSelect: () => {
                                                                                    updateSortOrder("DESC");
                                                                                }, children: "Sort by Newest" }), _jsx(CatListItem, { "data-test": "sort-by-earliest", onBlSelect: () => {
                                                                                    updateSortOrder("ASC");
                                                                                }, children: "Sort by Earliest" })] }) })] })) : (_jsx("div", { className: "flex items-center text text-black", children: _jsx("span", { children: "Sort" }) })) }) }) })] }) }), _jsx(CatTableBody, { children: populateFaultsData() })] }) }), !assetFaultsData?.[0]?.error && (_jsxs("div", { className: "flex justify-between items-center", children: [_jsxs("div", { className: "w-1/3 ml-[15px]", children: [" ", assetFaultsCount?.count || 0, " Total "] }), _jsx(CatPagination, { arialabel: "Pagination footer", className: "alerts-pagination", currentItem: pageNumber, "data-test": "alerts-pagination", hidePageSize: true, onBlPageChange: (event) => {
                                    const page = event.detail.pageNumber;
                                    setPageNumber(page);
                                    getAssetsFaultsData(page, alertsSortOrder);
                                }, pageSize: 5, slot: "footer", totalRecords: assetFaultsCount?.count || 0 }, pageNumber)] }))] }))] }));
};
export default Alerts;
